export enum TransferConstructionSiteEnum {
  //Estados
  abierta = 1,
  cerrada = 2,
  anulada = 3,
  impresa = 4,
  enTransito = 5
}